import { getInnerQueryData } from "@nimble/react-requests/data/response-utils";

import JobDetailsDrawerView from "@/components/shared/jobs/job-details-drawer/job-details-drawer.view";
import useJobPostingData from "@/hooks/data/use-job-posting";
import useSchoolData from "@/hooks/data/use-school-data";
import useStateConfig from "@/hooks/use-state-config";
import { useTrackJobViewed } from "@/hooks/use-track-job-viewed";

interface JobDetailsContentProps {
  jobId: string;
  schoolNcesId: string;
  onClose: () => void;
}

export default function JobDetailsDrawerContainer({
  jobId,
  schoolNcesId,
  onClose,
}: JobDetailsContentProps) {
  const jobQuery = useJobPostingData({ jobId });
  const schoolQuery = useSchoolData({ ncesId: schoolNcesId });
  const stateConfig = useStateConfig();
  const districtId = getInnerQueryData(schoolQuery)?.district?.nces_id;

  useTrackJobViewed({
    jobId,
    schoolNcesId,
    districtId: districtId || "N/A",
    state: stateConfig.abbreviation,
  });

  return (
    <JobDetailsDrawerView
      jobQuery={jobQuery}
      schoolQuery={schoolQuery}
      onClose={onClose}
      stateConfig={stateConfig}
    />
  );
}
